import type { FixtureEntity } from "~types/fixtureEntity.ts";
import type { FixtureResources } from "~types/fixture.ts";

export const getFixtureCompetitorsNames = (
  isHome: boolean,
  competitors: FixtureEntity[] | undefined = [],
  resources: FixtureResources | undefined = {},
) => {
  const competitor = competitors?.find((x) => x.isHome === isHome);
  return resources?.[competitor?.entity?.resourceType || ""]?.[competitor?.entity?.id || ""]?.nameFullLocal;
};